export var PartitionType;
(function (PartitionType) {
    PartitionType["PARTITION_TYPE_BUCKET_PATH"] = "BUCKET_PATH";
})(PartitionType || (PartitionType = {}));
